import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SearchPipe } from './search.pipe';
import { LangPipe } from './lang.pipe';
import { AsyncLangPipe } from './asynclang.pipe';
import { SanitizePipe } from './sanitize.pipe';
import { ToUserUnitPipe } from '@library/utils/pipes/to-user-unit.pipe';
import { ToDisplayValuePipe } from '@library/utils/pipes/to-display-value.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        LangPipe,
        AsyncLangPipe,
        SanitizePipe
    ],
    exports: [
        SearchPipe,
        LangPipe,
        AsyncLangPipe,
        SanitizePipe,
        CommonModule,
        ToUserUnitPipe,
        ToDisplayValuePipe,
    ],
    declarations: [
        SearchPipe,
        LangPipe,
        AsyncLangPipe,
        SanitizePipe,
        ToUserUnitPipe,
        ToDisplayValuePipe,
    ]
})
export class PipesModule {}
